<div class="modal-header">
  <h3 class="modal-title">{{ title }}</h3>
  <div class="header-actions">
    <i class="fa" [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       style="margin-right: 10px; cursor: pointer;" (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<div class="modal-body bgColorWhite body-scroll" [hidden]="minimise">
  @if (showData) {
<div class="text-center boldText"><h3>{{ title }}</h3></div>
}

  @if (loading) {
<div class="formLoader">
    <i class="fa fa-spinner fa-spin gt-refresh"></i>
  </div>
}

  @if (!loading) {
<div style="margin-left: 30px; margin-right: 30px;">
    <div class="form-group row">
      <label class="col-form-label">Tax Year</label>
      <select class="form-control ddWidth" [ngModel]="selectedTaxYear" (ngModelChange)="onTaxYearChange($event)">
        <option value="">Select</option>
        @for (item of taxYearSL; track $index) {
<option [value]="item.value">{{ item.label }}</option>
}
      </select>
      <button type="button" class="save-button" style="margin-left: 10px;" (click)="refreshData()">Refresh</button>
    </div>

    @if (displayTable) {
<div class="col-md-12 boldText" style="width:100%;">
      <table class="table table-bordered table-striped table-condensed custom-table">
        <thead>
          <tr>
            <th>Description</th>
            <th>Cite</th>
            <th class="rightAlign">Total Amount</th>
            @for (col of tableColumns; track $index) {
<th class="rightAlign">{{ col }}</th>
}
          </tr>
        </thead>
        <tbody>
          @for (row of tableRows; track $index) {
<tr>
            <td>{{ row['Description'] }}</td>
            <td>{{ row['Cite'] }}</td>
            <td class="rightAlign">{{ row['Total Amount'] }}</td>
            @for (col of tableColumns; track $index) {
<td class="rightAlign">{{ row[col] }}</td>
}
          </tr>
}
        </tbody>
      </table>
    </div>
}
  </div>
}
</div>

<div class="modal-footer" [hidden]="minimise">
  <button class="cancel-button" type="button" (click)="cancel()">Cancel</button>
</div>
